import { windowAsAny } from "../windowAsAny/windowAsAny";

export const locationPrepend = () =>
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    windowAsAny().isRedDeerDevStage
        ? "https://stage-reddeer.reddeer.com"
        : // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          windowAsAny().isRedDeerDevServer
          ? "http://localhost:8080"
          : "";
